<template>
  <div class="additional-section">
    <div class="header-action">
      <SearchBox
        :title="`พิมพ์ชื่อ${titleName}ที่ต้องการค้นหา`"
        @typed="(q) => $emit('searchItem', { q, type })"
        style="display: inline-block; width: 50%"
        class="mr-2"
      />
      <b-button @click="showModalCreate()" variant="primary">
        <b-icon icon="plus"></b-icon>
        เพิ่ม{{ titleName }}
      </b-button>
    </div>

    <b-table
      :items="items"
      :fields="fields"
      :busy="isLoading"
      :per-page="perPage"
      :current-page="currentPage"
      striped
      show-empty
    >
      <template #table-colgroup="scope">
        <col
          v-for="field in scope.fields"
          :key="field.key"
          :style="field.style"
        />
      </template>
      <template slot="table-busy" class="text-center text-danger my-2">
        <Loading />
      </template>
      <template #empty>
        <p class="text-center">ไม่มีข้อมูล</p>
      </template>
      <template v-slot:cell(actions)="data">
        <div class="action-button">
          <b-button
            @click="showModalEdit(data.item[keyName.id])"
            variant="outline-primary"
          >
            แก้ไข
          </b-button>
          <span
            :id="`delete-action-${type}-${data.item[keyName.id]}`"
            class="d-inline-block delete-action-wrapper"
            tabindex="0"
          >
            <b-button
              @click="showModalDelete(data.item[keyName.id])"
              variant="outline-danger"
              :disabled="hasCourses(data.item)"
            >
              <b-icon icon="trash"></b-icon>
            </b-button>
          </span>
          <b-tooltip
            v-if="hasCourses(data.item)"
            :target="`delete-action-${type}-${data.item[keyName.id]}`"
            placement="left"
            variant="dark"
            custom-class="delete-tooltip-popover"
          >
            <div class="delete-tooltip">
              <div>ไม่สามารถลบได้ เนื่องจากถูกใช้ในคอร์ส</div>
              <ul>
                <li
                  v-for="course in displayedCourses(data.item)"
                  :key="course.id"
                >
                  {{ course.name }}
                </li>
              </ul>
              <div v-if="hasMoreCourses(data.item)">
                <template v-if="!isExpanded(data.item)">
                  และคอร์สอื่น ๆ
                  <a
                    class="more-courses-link"
                    @click="toggleExpand(data.item)"
                  >
                    ดูเพิ่มเติม
                  </a>
                </template>
                <a
                  v-else
                  class="more-courses-link"
                  @click="toggleExpand(data.item)"
                >
                  ดูน้อยลง
                </a>
              </div>
            </div>
          </b-tooltip>
        </div>
      </template>
    </b-table>
    <b-row class="mt-3" v-if="items.length > 0">
      <b-col cols="6">
        <form class="form-inline">
          <div class="form-group mb-2">
            <label>แสดง</label>
          </div>
          <div class="form-group ml-2 mb-2">
            <b-form-select v-model="localPerPage" size="sm">
              <option value="5">5</option>
              <option value="10">10</option>
              <option value="15">15</option>
              <option value="30">30</option>
              <option value="50">50</option>
            </b-form-select>
          </div>
          <div class="form-group ml-2 mb-2">
            <label>
              จาก
              {{ items.length }}
              รายการ
            </label>
          </div>
        </form>
      </b-col>
      <b-col cols="6" v-if="items.length > 0">
        <nav class="float-right">
          <b-pagination
            v-model="localCurrentPage"
            :per-page="perPage"
            :total-rows="items.length"
            aria-controls="member-list"
            last-number
          >
          </b-pagination>
        </nav>
      </b-col>
    </b-row>

    <b-modal
      v-model="isShowModal"
      :title="modalTitle"
      size="lg"
      centered
      hide-footer
    >
      <b-form-group :label="'ชื่อ' + titleName" label-for="input-1">
        <b-form-input id="input-1" v-model="additionalName" trim></b-form-input>
      </b-form-group>
      <b-form-group label="รายละเอียด" label-for="textarea-1">
        <b-form-textarea
          id="textarea-1"
          v-model="detail"
          rows="3"
          max-rows="6"
          trim
        ></b-form-textarea>
      </b-form-group>
      <div class="text-right">
        <b-button @click="confirm()" variant="primary" :disabled="isEmptyInput">
          บันทึก
        </b-button>
      </div>
    </b-modal>

    <b-modal v-model="isShowSuccessModal" centered hide-header hide-footer>
      <div class="modal-section">
        <b-icon icon="check-circle" variant="success" font-scale="7.5"></b-icon>
        <h3>
          {{ actionType === "CREATE" ? "เพิ่ม" : "แก้ไข" }}ประเภทวิชาสำเร็จ
        </h3>
        <b-button variant="primary" @click="isShowSuccessModal = false">
          เสร็จสิ้น
        </b-button>
      </div>
    </b-modal>

    <b-modal v-model="isShowDeleteModal" centered hide-header hide-footer>
      <div class="modal-section">
        <b-icon
          icon="exclamation-triangle"
          variant="warning"
          font-scale="7.5"
        ></b-icon>
        <h3>ยืนยันการลบ{{ titleName }}</h3>
        <div class="confirm-button-group">
          <b-button
            @click="isShowDeleteModal = false"
            variant="outline-secondary"
          >
            ยกเลิก
          </b-button>
          <b-button @click="confirm()" variant="danger">ยืนยัน</b-button>
        </div>
      </div>
    </b-modal>

    <b-modal
      v-model="isShowCourseInUseModal"
      centered
      hide-header
      hide-footer
    >
      <div class="modal-section">
        <b-icon
          icon="exclamation-triangle"
          variant="warning"
          font-scale="7.5"
        ></b-icon>
        <h3>ไม่สามารถลบได้ เนื่องจากถูกใช้ในคอร์ส</h3>
        <ul class="course-in-use-list">
          <li v-for="(name, idx) in courseInUseList.slice(0, 3)" :key="idx">
            {{ name }}
          </li>
        </ul>
        <div v-if="courseInUseList.length > 3">และคอร์สอื่น ๆ</div>
        <b-button variant="primary" @click="isShowCourseInUseModal = false">
          ปิด
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import SearchBox from "@/components/shared/SearchBox";
import Loading from "@/components/shared/Loading";

export default {
  props: {
    type: { type: String, default: "SUBJECT" },
    items: {
      type: Array,
      default: () => {
        [];
      },
    },
    isLoading: { type: Boolean, default: false },
    currentPage: Number,
    perPage: [Number, String],
    searchValue: String,
  },
  components: {
    SearchBox,
    Loading,
  },
  data() {
    return {
      isShowModal: false,
      isShowDeleteModal: false,
      additionalId: null,
      additionalName: "",
      detail: "",
      actionType: true,
      isShowSuccessModal: false,
      isShowCourseInUseModal: false,
      courseInUseList: [],
      expandedIds: [],
    };
  },
  computed: {
    ...mapGetters("CourseManagement", [
      "subjectType",
      "academicLevel",
      "academicTerm",
    ]),
    fields() {
      return [
        {
          key: this.keyName.name,
          label: "ชื่อ" + this.titleName,
          formatter: (value) => {
            return value === null || value === "" ? "-" : value;
          },
          style: { minWidth: "150px" },
        },
        {
          key: this.keyName.desc,
          label: "รายละเอียด",
          formatter: (value) => {
            return value === null || value === "" ? "-" : value;
          },
        },
        { key: "actions", label: "" },
      ];
    },
    localCurrentPage: {
      get() {
        return this.currentPage;
      },
      set(val) {
        this.$emit("update:currentPage", val);
      },
    },
    localPerPage: {
      get() {
        return this.perPage;
      },
      set(val) {
        this.$emit("update:perPage", val);
      },
    },
    titleName() {
      const types = {
        SUBJECT: "ประเภทวิชา",
        LEVEL: "ระดับชั้นเรียน",
        TERM: "ภาคการศึกษา",
      };
      return types[this.type] || "";
    },
    keyName() {
      const types = {
        SUBJECT: {
          id: "subjectTypeId",
          name: "subjectTypeName",
          desc: "subjectTypeDescription",
        },
        LEVEL: {
          id: "academicLevelId",
          name: "academicLevelName",
          desc: "academicLevelDescription",
        },
        TERM: {
          id: "academicTermId",
          name: "academicTermName",
          desc: "academicTermDescription",
        },
      };
      return types[this.type] || { id: "", name: "", desc: "" };
    },
    modalTitle() {
      let actionName =
        this.actionType === "CREATE"
          ? "เพิ่ม"
          : this.actionType === "EDIT"
          ? "แก้ไข"
          : "";
      return actionName + this.titleName;
    },
    isEmptyInput() {
      return this.additionalName ? false : true;
    },
  },
  mounted() {},
  methods: {
    ...mapActions("CourseManagement", [
      "createSubjectType",
      "createAcademicLevel",
      "createAcademicTerm",
      "getSubjectType",
      "getAcademicLevel",
      "getAcademicTerm",
      "updateSubjectType",
      "updateAcademicLevel",
      "updateAcademicTerm",
      "deleteSubjectType",
      "deleteAcademicLevel",
      "deleteAcademicTerm",
    ]),
    async confirm() {
      let params = {
        attributes: {
          [this.keyName.name]: this.additionalName,
          [this.keyName.desc]: this.detail,
        },
      };

      if (this.actionType === "EDIT") {
        params[this.keyName.id] = this.additionalId;
      } else if (this.actionType === "DELETE") {
        params = {
          [this.keyName.id]: this.additionalId,
        };
      }

      const actionMap = {
        SUBJECT: {
          CREATE: this.createSubjectType,
          EDIT: this.updateSubjectType,
          DELETE: this.deleteSubjectType,
        },
        LEVEL: {
          CREATE: this.createAcademicLevel,
          EDIT: this.updateAcademicLevel,
          DELETE: this.deleteAcademicLevel,
        },
        TERM: {
          CREATE: this.createAcademicTerm,
          EDIT: this.updateAcademicTerm,
          DELETE: this.deleteAcademicTerm,
        },
      };

      const executeAction = actionMap[this.type]?.[this.actionType];

      if (executeAction) {
        try {
          await executeAction(params);
        } catch (error) {
          if (this.actionType === "DELETE") {
            const courses = error?.response?.data?.courses || [];
            if (courses.length > 0) {
              this.courseInUseList = courses;
              this.isShowCourseInUseModal = true;
            } else {
              this.$bvToast.toast(`ไม่สามารถลบ${this.titleName}ได้`, {
                title: "เกิดข้อผิดพลาด",
                variant: "danger",
                solid: true,
                autoHideDelay: 5000,
              });
            }
          }
          this.isShowModal = false;
          this.isShowDeleteModal = false;
          this.$emit("fetchData");
          return;
        }
      }

      if (this.actionType === "CREATE" || this.actionType === "EDIT") {
        this.isShowSuccessModal = true;
      }
      this.isShowModal = false;
      this.isShowDeleteModal = false;
      this.$emit("fetchData");
    },
    showModalCreate() {
      this.actionType = "CREATE";
      this.isShowModal = true;
      this.additionalName = "";
      this.detail = "";
    },
    async showModalEdit(id) {
      this.actionType = "EDIT";
      this.isShowModal = true;

      if (this.type === "SUBJECT") {
        await this.getSubjectType(id);
        this.additionalId = this.subjectType[this.keyName.id];
        this.additionalName = this.subjectType[this.keyName.name];
        this.detail = this.subjectType[this.keyName.desc];
      } else if (this.type === "LEVEL") {
        await this.getAcademicLevel(id);
        this.additionalId = this.academicLevel[this.keyName.id];
        this.additionalName = this.academicLevel[this.keyName.name];
        this.detail = this.academicLevel[this.keyName.desc];
      } else if (this.type === "TERM") {
        await this.getAcademicTerm(id);
        this.additionalId = this.academicTerm[this.keyName.id];
        this.additionalName = this.academicTerm[this.keyName.name];
        this.detail = this.academicTerm[this.keyName.desc];
      }
    },
    showModalDelete(id) {
      this.actionType = "DELETE";
      this.additionalId = id;
      this.isShowDeleteModal = true;
    },
    hasCourses(item) {
      return Array.isArray(item.courses) && item.courses.length > 0;
    },
    hasMoreCourses(item) {
      return Array.isArray(item.courses) && item.courses.length > 5;
    },
    isExpanded(item) {
      return this.expandedIds.includes(item[this.keyName.id]);
    },
    displayedCourses(item) {
      if (!Array.isArray(item.courses)) return [];
      return this.isExpanded(item) ? item.courses : item.courses.slice(0, 5);
    },
    toggleExpand(item) {
      const id = item[this.keyName.id];
      const idx = this.expandedIds.indexOf(id);
      if (idx === -1) {
        this.expandedIds.push(id);
      } else {
        this.expandedIds.splice(idx, 1);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.additional-section {
  display: flex;
  flex-direction: column;
  gap: 40px;

  .header-action {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .action-button {
    display: flex;
    gap: 15px;
    justify-content: flex-end;

    button {
      background-color: #fff;
    }

    button:hover {
      background-color: #007bff;
    }

    button:disabled,
    button:disabled:hover {
      background-color: #e9ecef;
      border-color: #868E96;
      color: #868E96;

      pointer-events: none;
    }
  }
}

.delete-tooltip {
  text-align: left;

  ul {
    margin: 4px 0 0;
    padding-left: 18px;
    list-style-type: disc;
    list-style-position: outside;
    max-height: 240px;
    overflow-y: auto;

    li {
      display: list-item;
    }

    &::-webkit-scrollbar {
      width: 6px;
    }
    &::-webkit-scrollbar-thumb {
      background-color: rgba(255, 255, 255, 0.4);
      border-radius: 3px;
    }
  }

  .more-courses-link {
    color: #fff;
    text-decoration: underline;
    cursor: pointer;
  }
}
.modal-section {
  display: flex;
  flex-direction: column;
  gap: 30px;
  align-items: center;

  h3 {
    font-weight: 600;
  }

  .confirm-button-group {
    display: flex;
    gap: 15px;
  }
}

.course-in-use-list {
  align-self: stretch;
  text-align: left;
  margin: -18px 0 0;
  padding-left: 18px;
  list-style-type: disc;
  list-style-position: outside;
  max-height: 240px;
  overflow-y: auto;

  li {
    display: list-item;
  }
}
</style>

<style lang="scss">
.delete-tooltip-popover {
  .tooltip-inner {
    background-color: #000;
    color: #fff;
    max-width: 320px;
  }

  &.bs-tooltip-bottom .arrow::before,
  &.bs-tooltip-auto[x-placement^="bottom"] .arrow::before {
    border-bottom-color: #000;
  }

  &.bs-tooltip-left .arrow::before,
  &.bs-tooltip-auto[x-placement^="left"] .arrow::before {
    border-left-color: #000;
  }
}
</style>
